import {Injectable, InputSignal} from "@angular/core";
import {PlanningRegion} from "../models/planning_region.model";

@Injectable({
  providedIn: 'root',
})
export class PlanningRegionService {

  hasCommentByDateAndScreenId(data: InputSignal<PlanningRegion>,
                              wednesday: InputSignal<string>,
                              screenId: number): boolean {
    return data().screen_comment != null
      && data().screen_comment[wednesday()]?.[screenId]
      && data().screen_comment[wednesday()]?.[screenId].length > 0
      && data().screen_comment[wednesday()]?.[screenId][0].commentaire != null;
  }
  getCommentByDateAndScreenId(data: InputSignal<PlanningRegion>,
                              wednesday: InputSignal<string>,
                              screenId: number): string {
    let screenComment = data().screen_comment[wednesday()]?.[screenId]?.[0];
    let dateDebut = screenComment?.date_debut;
    let dateFin = screenComment?.date_fin;
    let commentaire = screenComment?.commentaire;
    return `${dateDebut} - ${dateFin} : ${commentaire}`;
  }
}
